/** Language workflow copy; course titles, stage codes and customer notes stay unchanged. */
export const languageProgressArabic: Record<string, string> = {
  'Language stage and level': 'مرحلة اللغة والمستوى',
  'Stage': 'المرحلة',
  'Level': 'المستوى',
  'Stage / Level': 'المرحلة / المستوى',
  'Select stage': 'اختار المرحلة',
  'Select level': 'اختار المستوى',
  'Choose stage first': 'اختار المرحلة الأول',
  'Choose Stage First': 'اختار المرحلة الأول',
  'All Stages': 'كل المراحل',
  'All Levels': 'كل المستويات',
  'Level {0}': 'المستوى {0}',
  '{0} — Level {1}': '{0} — المستوى {1}',
  'Language level': 'مستوى اللغة',
  'Language study progress': 'متابعة دراسة اللغة',
  'Language Study Progress': 'متابعة دراسة اللغة',
  'Language Booking': 'حجز مستوى اللغة',
  'Language Course': 'كورس اللغة',
  'English': 'إنجليزي',
  'German': 'ألماني',
  'Booked / Waiting to Start': 'محجوز / مستني البداية',
  'Studying': 'بيدرس حاليًا',
  'Completed — Not Continued': 'خلص المستوى — لسه ماكملش',
  'Stopped During Level': 'وقف أثناء المستوى',
  'Progress Not Recorded': 'المتابعة لسه متسجلتش',
  'No level selected': 'لسه مفيش مستوى متحدد',
  '· No level selected': '· لسه مفيش مستوى متحدد',
  'Last Completed Level': 'آخر مستوى خلصه',
  'Completion Date': 'تاريخ إنهاء المستوى',
  'Stop Date': 'تاريخ التوقف',
  'Next Level': 'المستوى الجاي',
  'Package Levels Consumed': 'المستويات المستخدمة من الباقة',
  'Package Starts At': 'بداية الباقة من مستوى',
  'Not recorded': 'مش متسجل',
  'Not assigned': 'لسه متحددش',
  'Loading language progress…': 'جاري تحميل متابعة اللغة…',
  'Set Booking Level': 'حدد مستوى الحجز',
  'Book Next Level': 'احجز المستوى الجاي',
  'Record Completion': 'سجل إنهاء المستوى',
  'Record Stop': 'سجل التوقف',
  'Record Study Start': 'سجل بداية الدراسة',
  'Progress Date': 'تاريخ المتابعة',
  'Note': 'ملاحظة',
  'Saving…': 'جاري الحفظ…',
  'Save Booking': 'احفظ الحجز',
  'Save Completion': 'احفظ إنهاء المستوى',
  'Save Stop': 'احفظ التوقف',
  'Save Study Start': 'احفظ بداية الدراسة',
  'Level History': 'سجل المستويات',
  'No progress history recorded.': 'لسه مفيش سجل لمتابعة المستويات.',
  'Select the date of this progress change.': 'اختار تاريخ التغيير في المتابعة.',
  'Language level booked.': 'تم حجز مستوى اللغة.',
  'Level completion recorded.': 'تم تسجيل إنهاء المستوى.',
  'Student stop recorded.': 'تم تسجيل توقف الطالب.',
  'Study progress recorded.': 'تم تسجيل متابعة الدراسة.',
  'Could not save language progress.': 'ماقدرناش نحفظ متابعة اللغة.',
  'Could not update language progress.': 'ماقدرناش نحدّث متابعة اللغة.',
  'Language progress could not be loaded.': 'ماقدرناش نحمّل متابعة اللغة.',
  'Level Reference': 'المستوى المقصود',
  'Current / Booked Level': 'المستوى الحالي / المحجوز',
  'Study Status': 'حالة الدراسة',
  'All Study Statuses': 'كل حالات الدراسة',
  'No Progress Date Filter': 'من غير فلتر تاريخ المتابعة',
  'Level Completion Date': 'تاريخ إنهاء المستوى',
  'Progress From': 'المتابعة من',
  'Progress To': 'المتابعة لحد',
  'Language progress from': 'متابعة اللغة من',
  'Language progress to': 'متابعة اللغة لحد',
  'Enter valid dates. From must not be after To.': 'اكتب تواريخ صحيحة. تاريخ البداية لازم يكون قبل النهاية أو نفس اليوم.',
  'Stopped {0}': 'وقف يوم {0}',
  'Last completed {0}': 'آخر إنهاء يوم {0}',
  'Select a stage and level for the language course.': 'اختار المرحلة والمستوى لكورس اللغة.',
  'Progress date cannot precede the latest transition': 'تاريخ المتابعة ماينفعش يسبق آخر تغيير متسجل',
  'occurred_at cannot be in the future': 'تاريخ المتابعة ماينفعش يكون في المستقبل',
  'Book the same level or the next level in sequence': 'احجز نفس المستوى أو المستوى اللي بعده بالترتيب',
};
